import { useCallback, useMemo, useState } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    collapsedArea: {
      position: "absolute",
      zIndex: 2,
      borderRadius: "10px",
    },
    collapsedPaper: {
      textAlign: "center",
      color: "#673368",
    },
    uncollapsedArea: {
      overflow: "auto",
      boxShadow: theme.shadows["12"],
    },
  }),
);

const useAppFilterableSelect = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(
    () => ({
      collapsedArea: {
        container: styles.collapsedArea,
        entered: styles.uncollapsedArea,
      },
      collapsedPaper: {
        root: styles.collapsedPaper,
      },
    }),
    [styles],
  );
  const atomicStyles = useAtomicStyles();
  const [checked, setChecked] = useState(false);

  const handleCollapse = useCallback(() => {
    setChecked(false);
  }, [setChecked]);
  const handleUncollapse = useCallback(() => {
    setChecked(true);
  }, [setChecked]);

  return {
    styles,
    classes,
    atomicStyles,
    handleCollapse,
    handleUncollapse,
    checked,
  };
};

export { useAppFilterableSelect as default };
